import NavigationMenuFragment = Queries.cms_Navigation
import NavigationDropdownItem = Queries.cms_ComponentUtilsNavigationDropdownItem
import {
  NavigationCta,
  NavigationItem,
  NavigationItemWithDropdown,
  NavigationMenuProps,
} from '../../components/organisms/navigation-menu'
import { mapFragmentToImage } from '../other/images.mapper'
import { mapNavigationLink, sanitizeSlug } from '../link.mapper'

type Maybe<T> = NonNullable<T> | undefined | null

export function mapNavigationMenuProps(fragment: NavigationMenuFragment): NavigationMenuProps {
  const logo = mapFragmentToImage(fragment?.logo)

  const ctaButton: NavigationCta = {
    title: fragment?.ctaTitle ?? '',
    link: sanitizeSlug(fragment?.ctaUrl ?? ''),
    openInNewTab: Boolean(fragment?.openInNewTab),
  }

  const menuItems =
    fragment?.menuEntry
      ?.filter(menuItem => menuItem?.title != null)
      ?.map(menuItem => {
        const dropdownItems = menuItem?.menuEntry
          ?.filter((dropdownEntry: Maybe<NavigationDropdownItem>) => dropdownEntry?.title != null)
          ?.map((dropdownEntry: Maybe<NavigationDropdownItem>) => ({
            title: dropdownEntry?.title ?? '',
            link: mapNavigationLink(dropdownEntry?.url, dropdownEntry?.page),
          }))

        if (dropdownItems && dropdownItems?.length > 0) {
          return { title: menuItem?.title ?? '', dropdownItems } as NavigationItemWithDropdown
        }

        return {
          title: menuItem?.title ?? '',
          link: mapNavigationLink(menuItem?.url, menuItem?.page),
        } as NavigationItem
      }) ?? []

  return {
    logo,
    ctaButton,
    items: menuItems,
  }
}
